export const SELECTED_SONGS = "SELECTED_SONGS";
